import { render, staticRenderFns } from "./Ganhadores.vue?vue&type=template&id=4a253810&scoped=true&"
import script from "./Ganhadores.vue?vue&type=script&lang=js&"
export * from "./Ganhadores.vue?vue&type=script&lang=js&"
import style0 from "./Ganhadores.vue?vue&type=style&index=0&id=4a253810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a253810",
  null
  
)

export default component.exports